import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=5b718549&scoped=true&"
import script from "./AlertForm.vue?vue&type=script&lang=js&"
export * from "./AlertForm.vue?vue&type=script&lang=js&"
import style0 from "./AlertForm.vue?vue&type=style&index=0&id=5b718549&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b718549",
  null
  
)

export default component.exports